// extracted by mini-css-extract-plugin
export var header = "_fc-0";